module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.mapDialog) ? _c('div', [_c('el-row', [_c('i', {
    staticClass: "el-icon-close",
    staticStyle: {
      "margin-bottom": "10px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.mapDialog = false
      }
    }
  })]), _vm._v(" "), (_vm.isChina) ? _c('div', {
    attrs: {
      "id": "allmap"
    }
  }) : _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "gmap"
    }
  })], 1) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    attrs: {
      "id": "termialDetail"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_btn.tips'),
      "before-close": _vm.handleClose
    },
    model: {
      value: (_vm.showReset),
      callback: function($$v) {
        _vm.showReset = $$v
      },
      expression: "showReset"
    }
  }, [_c('span', [_vm._v(_vm._s(this.$t('lin_global.qrjxmm') + this.$t('terminal.details.regain')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showReset = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.opeTer('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_tipterop')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.opeTer('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_autocmpl')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.ter_status'),
      "size": "",
      "top": "15%"
    },
    on: {
      "close": function($event) {
        _vm.showdvst = false
      }
    },
    model: {
      value: (_vm.showdvst),
      callback: function($$v) {
        _vm.showdvst = $$v
      },
      expression: "showdvst"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.getTerWllxInfo.extendStatus,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "220",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "width": "180",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_mdclst'),
      "size": "",
      "top": "15%"
    },
    on: {
      "close": function($event) {
        _vm.showlog = false
      }
    },
    model: {
      value: (_vm.showlog),
      callback: function($$v) {
        _vm.showlog = $$v
      },
      expression: "showlog"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.sendLoad),
      expression: "sendLoad"
    }],
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mdlogs,
      "border": ""
    },
    on: {
      "row-click": _vm.showFunc
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "320",
      "label": _vm.$t('app_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "width": "120",
      "label": _vm.$t('app_param')
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_fcclst'),
      "size": "",
      "top": "15%"
    },
    on: {
      "close": function($event) {
        _vm.showfc = false;
        _vm.fclogs = []
      }
    },
    model: {
      value: (_vm.showfc),
      callback: function($$v) {
        _vm.showfc = $$v
      },
      expression: "showfc"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fclogs,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "320",
      "label": _vm.$t('app_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "width": "120",
      "label": _vm.$t('app_param')
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.ulscreentt,
      "size": "tiny",
      "top": "15%"
    },
    on: {
      "close": _vm.closeulDia
    },
    model: {
      value: (_vm.ulDia),
      callback: function($$v) {
        _vm.ulDia = $$v
      },
      expression: "ulDia"
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('lin_global.password')
    },
    model: {
      value: (_vm.ulsform.psw),
      callback: function($$v) {
        _vm.$set(_vm.ulsform, "psw", $$v)
      },
      expression: "ulsform.psw"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_wattime') + ' ' + _vm.$t('app_perms')
    },
    model: {
      value: (_vm.ulsform.time),
      callback: function($$v) {
        _vm.$set(_vm.ulsform, "time", $$v)
      },
      expression: "ulsform.time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeulDia
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.ulsform.psw || !_vm.ulsform.time,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.ulscreenRqs()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('app_confirm')) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticClass: "wrapper"
  }, [_c('el-button-group', {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "warning",
      "size": "small",
      "loading": _vm.cqLoad,
      "id": "orderExecCQ"
    },
    on: {
      "click": function($event) {
        _vm.orderExec('CQ')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-spinner ml5"
  }), _vm._v(_vm._s(_vm.$t('lin_btn.restart')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "danger",
      "size": "small",
      "loading": _vm.gjLoad,
      "id": "orderExecGJ"
    },
    on: {
      "click": function($event) {
        _vm.orderExec('GJ')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-power-off ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.gj')))])])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "primary",
      "size": "small",
      "loading": _vm.hfszLoad
    },
    on: {
      "click": function($event) {
        _vm.showReset = true
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-refresh ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.regain')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "id": "processInfo"
    },
    on: {
      "click": function($event) {
        _vm.processInfoVisible = true
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-pencil ml5"
  }), _vm._v(_vm._s(_vm.$t('lin_btn.edit')))])]), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "margin-right": "8px",
      "margin-left": "8px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ToLinkList
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.app_list')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ToLink
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cogs ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.app_install')))])])], 1), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.sendAnimate
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.send_animate')))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.btnShow,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.animate
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-repeat ml5"
  }), _vm._v(_vm._s(_vm.$t('terminal.details.reset_animate')))])])], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.showPathMap
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_trjmap')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), (_vm.baseinfo.lock_status != 1) ? _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.lockDevice(true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_lockdevice')) + "\n\t\t\t\t\t\t")]) : _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.lockDevice(false)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_unlockdevice')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.callclick
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.calltt) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.outputexcel
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_opterinfo')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ulscreenOpe
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ulscreentt) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "margin-right": "8px",
      "margin-left": "8px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showlog = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_lulog')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showdvst = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_lust')) + "\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFac),
      expression: "showFac"
    }],
    attrs: {
      "title": this.$t('app_saleSt') + '：' + this.$t('app_noresetfs'),
      "type": "error"
    }
  }), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAct),
      expression: "showAct"
    }],
    attrs: {
      "title": this.$t('app_actst') + '：' + this.$t('app_selfDestroy') + '(' + _vm.baseinfo.activDesc + ')',
      "type": "error"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.base_info')))])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "id": "",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    },
    model: {
      value: (_vm.baseinfo),
      callback: function($$v) {
        _vm.baseinfo = $$v
      },
      expression: "baseinfo"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_name')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.label_no')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_no) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_type')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_typeName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.label_model')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_modelName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.mechanismName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.label_manufid')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.manufName) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.guojia')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.nation) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.shengfen')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.province) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.city')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.city) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('app_region')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.district) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.label_address')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.address) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.memo) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_stinfo')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfNet
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "90px",
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseinfo.online_history),
      expression: "baseinfo.online_history"
    }],
    staticStyle: {
      "margin-top": "20px",
      "left": "17.166%",
      "height": "2px",
      "width": "65.766%",
      "background": "#9BD4FF",
      "position": "absolute"
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.peripheralLoading),
      expression: "peripheralLoading"
    }],
    staticStyle: {
      "width": "100%",
      "background": "none"
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "siimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.sticon0
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sititle",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.stlb0))]), _vm._v(" "), _c('div', {
    staticClass: "sidetail",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.sttm0))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "siimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.sticon1
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sititle",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.stlb1))]), _vm._v(" "), _c('div', {
    staticClass: "sidetail",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.sttm1))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "siimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.sticon2
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sititle",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.stlb2))]), _vm._v(" "), _c('div', {
    staticClass: "sidetail",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.sttm2))])])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.ter_status')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfNet
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.peripheralLoading),
      expression: "peripheralLoading"
    }],
    attrs: {
      "id": "baseInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('lin_global.net_status')
    }
  }, [(_vm.getTerWllxInfo.terminal_status === '1') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.online')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '2') ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.offline')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '0') ? _c('el-tag', {
    attrs: {
      "type": "gray",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.new_add')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '3') ? _c('el-tag', {
    attrs: {
      "type": "warning",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('app_sleep')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.getTerWllxInfo.terminal_status === '4') ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_btn.lock')) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.run_status')
    }
  }, [(_vm.baseinfo.terminal_runtime_status === '0') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.normal')) + "\n\t\t\t\t\t\t\t\t")]) : _c('el-tag', {
    attrs: {
      "type": "warning",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.showRuntime))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.net_type')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerWllxInfo.wlan) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('lin_global.ter_status')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.lock_status == 1 ? _vm.$t('lin_btn.lock') : _vm.$t('lin_global.normal')) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('label', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.system_info')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRf),
      expression: "isRf"
    }],
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfInfo
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.systemInfoLoading),
      expression: "systemInfoLoading"
    }],
    attrs: {
      "id": "getTerXtxxInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.launcher')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.launcher) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.system_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.system) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.ota_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.ota) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.hard_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.firmware) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.last_time')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.terminal_online_time) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.run_time')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.elapsedtime) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('app_comptime')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.baseinfo.compile ? _vm.baseinfo.compile : '-') + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": "IMEI"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerXtxxInfo.imei) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('label', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.hard_info')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRf),
      expression: "isRf"
    }],
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfhw
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.hardInfoLoading),
      expression: "hardInfoLoading"
    }],
    attrs: {
      "id": "hardInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.cpu')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.cpu) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.mem')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.mem) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('terminal.details.cpuUsed')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.cpuUsed) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('terminal.details.memUsed')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.hardwareInfo.memUsed) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "10px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('label', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_debuginfo')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRf),
      expression: "isRf"
    }],
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#20A0FF",
      "margin-top": "-20px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.rfadb
    }
  })]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.adbLoading),
      expression: "adbLoading"
    }],
    attrs: {
      "id": "hardInfo",
      "label-position": "left",
      "inline": "",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('app_adbstatus')
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.adbst))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('app_signstatus')
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.signst))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-left",
    attrs: {
      "label": _vm.$t('app_devicemode')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.dvst) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-right",
    attrs: {
      "label": _vm.$t('app_cerid')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getTerAdbztInfo.certInfo) + "\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.processInfoVisible) ? _c('processInfo', {
    attrs: {
      "pdata": _vm.pdata
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('terminal.details.hydh'),
      "size": "tiny",
      "top": "15%"
    },
    model: {
      value: (_vm.animateDialog),
      callback: function($$v) {
        _vm.animateDialog = $$v
      },
      expression: "animateDialog"
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "98%"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('terminal.details.tips')
    },
    model: {
      value: (_vm.animateId),
      callback: function($$v) {
        _vm.animateId = $$v
      },
      expression: "animateId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('terminal.details.kjdh'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('terminal.details.gjdh'),
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('terminal.details.kjlogo'),
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('app_wallpaper'),
      "value": "0"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.zbhy')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.logining,
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.details.mshy')) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.sendLoad),
      expression: "sendLoad",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('terminal.details.tsdh_title'),
      "top": "15%"
    },
    model: {
      value: (_vm.sendAnimateDialog),
      callback: function($$v) {
        _vm.sendAnimateDialog = $$v
      },
      expression: "sendAnimateDialog"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tloading),
      expression: "tloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": _vm.$t('terminal.details.animate_name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "position",
      "label": _vm.$t('terminal.details.animatType'),
      "formatter": _vm.formatStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": _vm.$t('terminal.details.createTime'),
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.ope'),
      "width": "81"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.send(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('lin_global.hqrz'),
      "top": "15%"
    },
    model: {
      value: (_vm.logDialog),
      callback: function($$v) {
        _vm.logDialog = $$v
      },
      expression: "logDialog"
    }
  }, [_c('el-form', [_c('el-row', {
    attrs: {
      "gutter": 10,
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('terminal.appLog.start_time')) + "\n\t\t\t\t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.start_time')
    },
    on: {
      "change": _vm.dataChange
    },
    model: {
      value: (_vm.start_time),
      callback: function($$v) {
        _vm.start_time = $$v
      },
      expression: "start_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('terminal.appLog.end_time')) + "\n\t\t\t\t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": _vm.$t('terminal.appLog.end_time')
    },
    on: {
      "change": _vm.dataChange1
    },
    model: {
      value: (_vm.end_time),
      callback: function($$v) {
        _vm.end_time = $$v
      },
      expression: "end_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.logLoad
    },
    on: {
      "click": _vm.getLog
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.hqrz')) + "\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_trjmap'),
      "top": "15%"
    }
  }, [(_vm.isChina) ? _c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('zt-map', {
    attrs: {
      "height": "480",
      "mapdata1": _vm.mapdata1,
      "mode": 1
    }
  })], 1)], 1) : _c('div', {
    staticStyle: {
      "height": "480px"
    },
    attrs: {
      "id": "gmap"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_taskMg ')))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.refreshList
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.shuaxin')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_taskType')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.taskType),
      callback: function($$v) {
        _vm.taskType = $$v
      },
      expression: "taskType"
    }
  }, _vm._l((_vm.statusSl), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_taskDetail'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.tName),
      callback: function($$v) {
        _vm.tName = $$v
      },
      expression: "tName"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cmData"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "label": _vm.$t('app_taskDetail'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.taskType == 19) ? _c('label', [_vm._v(_vm._s(_vm.comm[scope.row.fileName]))]) : _c('label', [_vm._v(_vm._s(scope.row.fileName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "taskType",
      "label": _vm.$t('app_taskType'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.statusShow[scope.row.taskType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "progress",
      "label": _vm.$t('app_process'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(scope.row.progress) + "%")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          attrs: {
            "typy": "success"
          }
        }, [_vm._v(_vm._s(_vm.statusNames[scope.row.status + '']))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "updateTime",
      "label": _vm.$t('app_pushTime'),
      "width": "176"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "cancelNums",
      "label": _vm.$t('app_operate'),
      "width": "116"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_pause'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(1, scope.row.status)),
            expression: "showBtn(1, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_continue'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(2, scope.row.status)),
            expression: "showBtn(2, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_ccdown'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(3, scope.row.status)),
            expression: "showBtn(3, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOperate(3, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-window-close"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_global.chongtui'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showBtn(4, scope.row.status)),
            expression: "showBtn(4, scope.row.status)"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.repush(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat"
        })])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelectDv,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f4caf6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/terminal/details.vue
// module id = 1057
// module chunks = 0